
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternOn as ObiLightLanternOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-on.js';
 
 
 

 
 export const ObiLightLanternOn = createComponent({
   react: React,
   tagName: 'obi-light-lantern-on',
   elementClass: ObiLightLanternOnElement,
   events: {
     
   }
  });
 
 